var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "url(#paint0_linear_2173_20285)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 80,
    rx: 4.85714,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2224 25.33C14.961 25.33 13.9197 25.0073 13.0984 24.362C12.2844 23.7167 11.705 22.844 11.3604 21.744L14.3084 21.04C14.3744 21.4433 14.587 21.7953 14.9464 22.096C15.3057 22.3893 15.687 22.536 16.0904 22.536C16.369 22.536 16.666 22.459 16.9814 22.305C17.304 22.151 17.535 21.9053 17.6744 21.568C17.7624 21.3553 17.8137 21.095 17.8284 20.787C17.843 20.479 17.8504 20.1233 17.8504 19.72V9.16H20.8864V19.72C20.8864 20.226 20.8827 20.666 20.8754 21.04C20.8754 21.414 20.8387 21.766 20.7654 22.096C20.6994 22.4187 20.5637 22.756 20.3584 23.108C19.911 23.8853 19.328 24.45 18.6094 24.802C17.8907 25.154 17.095 25.33 16.2224 25.33Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 39.7305C24.5 35.8761 18.9316 33.8868 17.0522 30.3122L16.9826 30.25L16.9478 30.3122C15.0684 33.8868 9.5 35.8761 9.5 39.7305C9.5 42.9631 14.268 44.2065 16.5998 41.5022C16.6346 41.3779 16.5998 42.3726 16.4258 42.9321C15.8689 44.5795 13.8503 47.004 12.8759 47.75C14.2332 46.7242 19.6972 46.7242 21.0545 47.75C20.08 47.004 18.1659 44.6727 17.5046 42.9321C17.3654 42.4347 17.2958 41.9685 17.261 41.4711C19.558 44.393 24.5 43.0253 24.5 39.7305Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5001 60.3148C50.5001 53.377 40.4769 49.7962 37.094 43.3619L36.9687 43.25L36.9061 43.3619C33.5233 49.7962 23.5001 53.377 23.5001 60.3148C23.5001 66.1337 32.0824 68.3717 36.2796 63.504C36.3423 63.2802 36.2796 65.0706 35.9664 66.0777C34.9641 69.0431 31.3307 73.4072 29.5766 74.75C32.0198 72.9036 41.8551 72.9036 44.2982 74.75C42.5441 73.4072 39.0987 69.2109 37.9084 66.0777C37.6578 65.1825 37.5325 64.3432 37.4699 63.448C41.6045 68.7074 50.5001 66.2456 50.5001 60.3148Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2173_20285",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.c1695da0b55aa8873fd44c29eafac293.svg";
export { ForwardRef as ReactComponent };